import { render, staticRenderFns } from "./ISAInsightRoomFallRate.vue?vue&type=template&id=5a8b9adf&scoped=true&"
import script from "./ISAInsightRoomFallRate.vue?vue&type=script&lang=js&"
export * from "./ISAInsightRoomFallRate.vue?vue&type=script&lang=js&"
import style0 from "./ISAInsightRoomFallRate.vue?vue&type=style&index=0&id=5a8b9adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b9adf",
  null
  
)

export default component.exports